/* eslint-disable */
import React, { useState, useEffect } from 'react'
import 'antd/dist/antd.css'
import { useDispatch } from 'react-redux'
import { Form, Input, Select, Cascader, Breadcrumb, Button, message, Spin } from 'antd';
import { CheckCircleFilled} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import InputPrefix from 'helper/InputPrefix'
import { sendContact, getContactUs, guestGetServicev2 } from 'api/hub'
import MarketCard from 'components/MarketCard'
// import { useHistory } from 'react-router-dom'

const { TextArea } = Input;

const PreorderForm= () => {
    const dispatch = useDispatch()
    const [statuscode, setstatuscode] = useState({
        status_desc_en: "",
        status_desc_tw: ""
      })
    const { t } = useTranslation()
    const { i18n } = useTranslation('ContactUs');
    const [form] = Form.useForm();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString)
    const serviceId = urlParams.get('serviceId')?urlParams.get('serviceId'):""
    const preorderId = urlParams.get('preorderId')?urlParams.get('preorderId'):""
    const LoginInfo = JSON.parse(localStorage.getItem('LoginInfo'))
    // Dropdownlist List Language setting
    const [IndustryList, setIndustryList] = useState([""])
    const [data, setData] = useState(undefined)
    const [loading, setLoading] = useState(false)
    const [Service, setService] = useState({
        service_info_data_en:[
            {
                service_name:"",
                summary:""
            }
        ],
        service_info_data_tw:[
            {
                service_name:"",
                summary:""
            }
        ]
    })

    useEffect(()=>{
          dispatch(guestGetServicev2({service_id:serviceId, tenant_id:LoginInfo.tenantId})).then(
            res => { 
                console.log(res.data.services[0])
                setstatuscode(res.data.services[0].preorder)
                setLoading(false)
                setService(()=>(res.data.services[0]))
                console.log(res.data.services[0])
            }
          )
        }
      ,[])

    const handletoPreorder = () => {
        window.location.href=`/portal/preorder`
    }

    const handletoMarketPlace = () => {
        window.location.href=`/`
    }
    

    useEffect(()=>{
        setLoading(true)
        const tenant_id = JSON.parse(localStorage.getItem('LoginInfo')).tenantId
        const LoginInfo = JSON.parse(localStorage.getItem('LoginInfo'))
        dispatch(getContactUs({parameter:tenant_id})).then(
            res => {
                console.log(res)
                setLoading(false)
                setIndustryList(res.data['industry_data_'+localStorage.getItem('lang')])
                setData(res.data)
                form.setFieldsValue({
                    "tenant_id": LoginInfo.tenantId,
                    "tenant_name": LoginInfo.tenantName,
                    "subscription_account": LoginInfo.account
                })
            }
        )
    },[])
    useEffect(()=>{
        console.log(data)
        if(data !== undefined){
            console.log(data)
            form.setFieldsValue({
                "tenant_name": data['tenantName'+i18n.language],
            })
            setIndustryList(data['industry_data_'+i18n.language])
        }

    },[i18n.language])
    const onFinish = (e) => {
        console.log(e, IndustryList)
        const tenant_id = JSON.parse(localStorage.getItem('LoginInfo')).tenantId
        const operator_id = JSON.parse(localStorage.getItem('LoginInfo')).operator_id
        setLoading(true)
        dispatch(sendContact({
            "tenant_id": tenant_id,
            "ip_address": "1.1.1.1",
            "operator_id": operator_id,
            "language": localStorage.getItem('lang'),
            "mail_data": {
              "subject": t('Contact.CustomerRequirements'),
              "mail_to": null,
              "content_json_data": {
                "service_id": null,
                "service_name": null,
                "vendor_id": null,
                "vendor_name": null,
                "tenant_id": tenant_id,
                "tenant_name": e.tenant_name,
                "industry_data": {
                  "industry_list": IndustryList
                },
                "last_name": e.last_name_p,
                "first_name": e.first_name_p,
                "title": e.position_p,
                "mobile_num": e.mobile_phone_p,
                "country_code": e.country_code_p,
                "phone_num": e.phone_p,
                "ext": e.ext_number_p,
                "email": e.Email_p,
                "mail_content": e.mail_content
              }
            }
          })).then(res=>{
            setLoading(false)
            console.log(res)
            if(res.code === 200){
                message.success({
                    content:t('Global.Success'),
                    className:"popupmessage"
                })
                window.location.reload()
            }
        })


    }
    
    return (
        <>
        <div className='innerlayout' style={{padding: "36px 0 0 130px"}}>
        <Spin tip={t('Global.Loading')} spinning={loading} >
            <Breadcrumb separator=">">
                <Breadcrumb.Item>WiAdvance App Market</Breadcrumb.Item>
                {/* <Breadcrumb.Item>{t('Global.member_center')}</Breadcrumb.Item> */}
                <Breadcrumb.Item className='lastchild'>{t('Menu.Preorder')}</Breadcrumb.Item>
            </Breadcrumb>
            <div className='headtitle'>
            {t('Menu.Preorder')}
            </div>
            <div className='cinfotitle' style={{fontWeight: '600',fontSize: '22px', paddingTop:'30px'}}>
                <span style={{color:'#7DB926'}}></span><span style={{fontWeight: '400',fontSize: '16px',lineHeight: '28px',letterSpacing: '0.1em',color: '#7C7C7C'}}>{t('Contact.preorderone')}{preorderId}{t('Contact.preordertwo')}</span>
            </div>
            <div className="registerlayout" style={{'margin':'30px 0px 0px 0px'}}>
            <div className="wibtnagreeC">
                <div className='btnleft'>
                    <Button type="primary" htmlType="submit" onClick={handletoMarketPlace}>{localStorage.getItem('lang')==='en'?'Go to MarketPlace':'繼續訂閱'}</Button>
                </div>
            </div>
            <div className="wibtnagreeC">
                <div className='btnleft'>
                    <Button type="primary" htmlType="submit" onClick={handletoPreorder}>{localStorage.getItem('lang')==='en'?'Order List':'訂單記錄'}</Button>
                </div>
            </div>
            <MarketCard data={{
                ...Service,
                'service_name_en':Service.service_info_data_en[0].service_name,
                'service_name_tw':Service.service_info_data_tw[0].service_name,
                'summary_tw':"訂單狀態：已建立",
                'summary_en':"Oder Status: Created",
                'isfree': "N",
                'sub_status': statuscode
              }} type='market'></MarketCard>
            </div>
            </Spin>
        </div>
        </>
    )
    }

export default (PreorderForm)